import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import {
  Map,
  Results,
  SearchInput,
  StoreSearch
} from '@thd-olt-component-react/store-search';
import { useMobileBreakpoint } from '../../utils/stylesUtils';

export const NearbyStores = ({
  title,
  storeNumber,
  omitStoreNumber,
  pageType,
  mapOptions,
  resultsOptions,
}) => {
  const [searchInput, setSearchInput] = useState(storeNumber);
  const isMobile = useMobileBreakpoint();

  const setSearchInputHandler = (value) => {
    setSearchInput(value);
  };

  const getLinkType = () => {
    switch (pageType) {
      case 'rentals':
        return 'rentals'
      case 'services':
        return 'services'
      case 'gardenCenter':
        return 'gardenCenter'
      default:
        return 'store'
    }
  }

  const getPhoneNumberType = () => {
    switch (pageType) {
      case 'rentals':
        return 'tool'
      case 'services':
        return 'services'
      default:
        return null
    }
  }

  const linkType = getLinkType();
  const phoneNumberType = getPhoneNumberType();

  const mapPropOptions = {
    ...mapOptions,
    height: isMobile ? '300px' : '731px',
    omitStoreNumber: mapOptions.omitStoreNumber || omitStoreNumber
  }

  const storeNumberToOmitResults = resultsOptions.omitStoreNumber || omitStoreNumber;

  return (
    <section className="sui-flex sui-flex-col sui-gap-2">
      <Typography variant="h2">{title}</Typography>

      <div className="sui-grid sui-grid-cols-4 sui-gap-3">
        <StoreSearch
          searchInput={searchInput || storeNumber}
          setSearchInput={setSearchInputHandler}
          pageSize={4}
        >
          <div className="sui-col-span-12 lg:sui-col-span-3">
            <Hydrator
              id="store-details-nearby-stores-map"
              scrollBuffer={500}
            >
              <Map mapOptions={mapPropOptions} />
            </Hydrator>
          </div>

          <div className="sui-col-span-12 lg:sui-col-span-1">
            <div className="sui-flex sui-flex-col sui-gap-3">
              <div>
                <Typography variant="h5">Find Another Store</Typography>
                <SearchInput hideUseCurrentLocation />
              </div>

              <Results
                disableScroll={isMobile}
                linkType={linkType}
                maxNumberOfResults={resultsOptions.maxNumberOfResults}
                omitStoreNumber={storeNumberToOmitResults}
                phoneNumberType={phoneNumberType}
              />
            </div>
          </div>
        </StoreSearch>
      </div>
    </section>
  )
};

NearbyStores.defaultProps = {
  title: 'Nearby Stores',
  omitStoreNumber: '',
  pageType: 'store',
  mapOptions: {
    disableOnMapViewChange: true,
    disableOnStoreClick: true,
    omitStoreNumber: ''
  },
  resultsOptions: {
    maxNumberOfResults: 3,
    omitStoreNumber: ''
  },
}

NearbyStores.propTypes = {
  storeNumber: PropTypes.string.isRequired,
  title: PropTypes.string,
  omitStoreNumber: PropTypes.string,
  pageType: PropTypes.oneOf(['store', 'rentals', 'services', 'gardenCenter']),
  mapOptions: PropTypes.shape({
    disableOnMapViewChange: PropTypes.bool,
    disableOnStoreClick: PropTypes.bool,
    omitStoreNumber: PropTypes.string
  }),
  resultsOptions: PropTypes.shape({
    maxNumberOfResults: PropTypes.number,
    omitStoreNumber: PropTypes.string
  }),
}

NearbyStores.dataModel = extend({}, StoreSearch);

export default NearbyStores
